import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ArrowCont,
  BackButton,
  CardButtonsCont,
  CardNavButton,
  CardsCont,
} from './CardsNavButtons.styles';
import Arrow from '@/assets/icons/chevron-left.svg?react';

interface ITab {
  name: string;
  value: string;
}
interface ICardsNavButtons {
  tabs: ITab[];
  activeTab: string;
  changeActiveTab: (tab: string) => void;
  backMethod?: () => void;
  backButtonVisible?: boolean;
}
const CardsNavButtons: FC<ICardsNavButtons> = ({
  tabs,
  changeActiveTab,
  activeTab,
  backMethod,
  backButtonVisible,
}) => {
  const { t } = useTranslation();

  const renderBackButton = useMemo(() => {
    return (
      !!backMethod &&
      backButtonVisible && (
        <BackButton data-testid="backButton" onClick={backMethod}>
          <ArrowCont>
            <Arrow />
          </ArrowCont>
          {t('report.topBar.back')}
        </BackButton>
      )
    );
  }, [backMethod, t]);
  const renderTabs = useMemo(() => {
    return tabs?.map((tab: ITab) => {
      const isActive = tab?.value === activeTab;
      return (
        <CardNavButton
          data-testid="navButton"
          id={tab?.value}
          key={tab?.name}
          active={isActive}
          onClick={() => !isActive && changeActiveTab(tab?.value)}
        >
          {tab.name}
        </CardNavButton>
      );
    });
  }, [activeTab, tabs]);
  return (
    <CardsCont id="CardsCont">
      {renderBackButton}
      <CardButtonsCont>{renderTabs}</CardButtonsCont>
    </CardsCont>
  );
};

export default CardsNavButtons;
